{
  "name": "Add Time Perk",
  "powerupName": "AddTimePerk",
  "levelUpDescriptions": [
    "AddTimePerkDescription1",
    "AddTimePerkDescription2",
    "AddTimePerkDescription3",
    "AddTimePerkDescription4",
    "AddTimePerkDescription5"
  ]
}